import css from './index.module.scss';
import { LineSpace } from '@/components/ProductComponents';
import { ImgCellsWithText, TextOnImage, TextWithImage } from '@/components/ProductDetailComponents';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { getImageSpec } from '@/utils/locals';
import OtherList from '@/components/ProductCommon/OtherList';
import NextImage from '@/components/NextImage';

const product: any = {
    us: ['product_ps_river_river_pro_720', 'product_ps_delta_delta_1300', 'product_ps_delta_delta_max'],
    cis: ['product_ps_delta_delta_pro', 'product_ps_delta_delta_max'],
    eu: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    uk: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    de: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    fr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    it: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    es: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    tw: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    kr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    cn: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    br: ['product_ps_river_river_256', 'product_ps_delta_delta_2', 'product_ps_delta_delta_2_max'],
    mx: ['product_ps_delta_delta_3_s', 'product_ps_delta_delta_2_max', 'product_ps_delta_delta_pro'],
    ph: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
};

export default function Content() {
    const { gloproductlist, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('400wsolarpanel');
    const languageT = (value: string) => t(`solarpanels_400w.${value}`);
    const imgSpec = getImageSpec(locale, ['de', 'fr', 'es', 'it', 'za', 'jp']);
    const webpUrl = '/media/solarpanel_400w/pc/';

    const item1 = {
        synopsis: languageT('third_title'),
        desc: languageT('third_des'),
        bgImgs: ['3_screen.webp', '3_screen.jpg'],
    };
    const textData1 = {
        img_url: ['4_camera.webp', '4_camera.jpg'],
        synopsis: languageT('four_title'),
        desc: languageT('four_des'),
    };
    const textData3 = {
        synopsis: languageT('five_title'),
        title: languageT('five_tip'),
        desc: languageT('five_des'),
        bgImgs: ['5.webp', '5.jpg'],
    };
    const textData4 = {
        synopsis: languageT('six_title'),
        title: languageT('six_tip'),
        desc: languageT('six_des'),
        bgImgs: ['6.webp', '6.jpg'],
    };
    const textWithImgItem1 = {
        title: languageT('seven_tip'),
        synopsis: languageT('seven_title'),
        desc: languageT('seven_des'),
        img_url: ['7.webp', '7.jpg'],
    };
    const textData5 = {
        img_url: ['8.webp', '8.jpg'],
        title: languageT('eight_title'),
        synopsis: languageT('eight_subtitle'),
        desc: languageT('eight_des'),
        tip: languageT('eight_tip'),
    };
    const textData6 = {
        img_url: ['9.webp', '9.jpg'],
        synopsis: languageT('night_subtitle'),
        title: languageT('night_title'),
        desc: languageT('night_des'),
    };
    const imgCellData = {
        guide: languageT('ten_title'),
        title: languageT('ten_subtitle'),
        desc1: languageT('ten_des'),
        desc2: languageT('ten_des1'),
        items: [
            {
                url: ['5_solar-panel1.webp', '5_solar-panel1.jpg'],
                guide: languageT('ten_item_title'),
                titleLeft: languageT('ten_item_hours'),
                desc: languageT('ten_item_des'),
            },
            {
                url: ['5_solar-panel2.webp', '5_solar-panel2.jpg'],
                guide: languageT('ten_item1_title'),
                titleLeft: languageT('ten_item1_hours'),
                desc: languageT('ten_item1_des'),
            },
            {
                url: ['5_solar-panel3.webp', '5_solar-panel3.jpg'],
                guide: languageT('ten_item2_title'),
                titleLeft: languageT('ten_item2_hours'),
                desc: languageT('ten_item2_des'),
            },
            {
                // @todo 缺少日本的图片
                url: [`5_solar-panel4_${imgSpec}.webp`, `5_solar-panel4_${imgSpec}.jpg`],
                guide: languageT('ten_item3_title'),
                titleLeft: languageT('ten_item3_hours'),
                desc: languageT('ten_item3_des'),
            },
        ],
    };

    return (
        <div className={`${css.animationWrapper} solarPanelModule`}>
            <LineSpace height={150} background="transparent" />
            <div className="banner-content">
                <div className="section section1">
                    <div className="section sec1-top">
                        <h3 className="tit">{languageT('second_output')}</h3>
                        <div className="bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solarpanel_400w/pc/sec1-top.webp')}
                                src={require('@publicLocal/product/solarpanel_400w/pc/sec1-top.jpg')}
                                className="fullImgs"
                                alt={languageT('second_output')}
                            />
                        </div>
                    </div>
                    <div className="section sec1-btm">
                        <div className="sec1-btm-l">
                            <h3
                                className="tit"
                                dangerouslySetInnerHTML={{
                                    __html: languageT('second_hight_conversion_rate'),
                                }}
                            ></h3>
                            <div className="bg-img">
                                <NextImage
                                    webpSrc={require('@publicLocal/product/solarpanel_400w/pc/sec1-btm_l.webp')}
                                    src={require('@publicLocal/product/solarpanel_400w/pc/sec1-btm_l.jpg')}
                                    className="fullImgs"
                                    alt={languageT('second_hight_conversion_rate')}
                                />
                            </div>
                        </div>
                        <div className="sec1-btm-r">
                            <h3
                                className="tit"
                                dangerouslySetInnerHTML={{
                                    __html: languageT('second_lightweight'),
                                }}
                            ></h3>
                            <div className="bg-img">
                                <NextImage
                                    webpSrc={require('@publicLocal/product/solarpanel_400w/pc/sec1-btm_r.webp')}
                                    src={require('@publicLocal/product/solarpanel_400w/pc/sec1-btm_r.jpg')}
                                    className="fullImgs"
                                    alt={languageT('second_lightweight')}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section section2">
                    <div className="section sec2-top">
                        <div className="section sec2-top-l">
                            <h3
                                className="tit"
                                dangerouslySetInnerHTML={{
                                    __html: languageT('second_adjustable'),
                                }}
                            ></h3>
                            <div className="bg-img">
                                <NextImage
                                    webpSrc={require('@publicLocal/product/solarpanel_400w/pc/sec2-top-l.webp')}
                                    src={require('@publicLocal/product/solarpanel_400w/pc/sec2-top-l.jpg')}
                                    className="fullImgs"
                                    alt={languageT('second_adjustable')}
                                />
                            </div>
                        </div>
                        <div className="section sec2-top-r">
                            <h3 className="tit">{languageT('second_easy_to_plug')}</h3>
                            <div className="bg-img">
                                <NextImage
                                    webpSrc={require('@publicLocal/product/solarpanel_400w/pc/sec2-top-r.webp')}
                                    src={require('@publicLocal/product/solarpanel_400w/pc/sec2-top-r.jpg')}
                                    className="fullImgs"
                                    alt={languageT('second_easy_to_plug')}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="section sec2-btm">
                        <h3 className="tit">
                            {languageT('second_ip')}
                            <span>{languageT('second_waterproof')}</span>
                        </h3>
                        <div className="bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solarpanel_400w/pc/sec2-btm.webp')}
                                src={require('@publicLocal/product/solarpanel_400w/pc/sec2-btm.jpg')}
                                className="fullImgs"
                                alt={languageT('solar_panels')}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <LineSpace height={150} background="transparent" />
            <TextOnImage
                data={item1}
                config={{
                    position: 'top',
                    descFontSize: locale === 'jp' ? '20' : '22',
                    webpUrl,
                }}
            />
            <LineSpace height={300} background="transparent" />
            <TextWithImage
                data={textData1}
                config={{
                    position: 'top',
                    descFontSize: locale === 'jp' ? '20' : '22',
                    synopsisFontSize: locale === 'de' ? 62 : 64,
                    webpUrl,
                }}
            />
            <LineSpace height={210} background="transparent" />
            <div className="container textData3">
                <TextOnImage
                    data={textData3}
                    config={{
                        position: locale == 'sa' ? 'right' : 'left',
                        descFontSize: locale === 'jp' ? '20' : '22',
                        synopsisFontSize: locale === 'de' ? 60 : 64,
                        webpUrl,
                    }}
                />
            </div>
            <LineSpace height={180} background="transparent" />
            <div className="container textData4">
                <TextOnImage
                    data={textData4}
                    config={{
                        position: locale == 'sa' ? 'left' : 'right',
                        descFontSize: locale === 'jp' ? '20' : '22',
                        webpUrl,
                    }}
                />
            </div>
            <LineSpace height={240} background="transparent" />
            <TextWithImage
                data={textWithImgItem1}
                config={{
                    position: 'top',
                    titleFontSize: 32,
                    imgHeight: '1080px',
                    imgWidth: '100%',
                    descFontSize: locale === 'jp' ? '20' : '22',
                    webpUrl,
                }}
            />
            <LineSpace height={280} background="transparent" />
            <TextWithImage
                data={textData5}
                config={{
                    position: 'top',
                    descFontSize: locale === 'jp' ? '20' : '22',
                    webpUrl,
                }}
            />
            <LineSpace height={280} background="transparent" />
            <TextWithImage
                data={textData6}
                config={{
                    position: 'top',
                    descFontSize: locale === 'jp' ? '20' : '22',
                    webpUrl,
                }}
            />
            <LineSpace height={280} background="transparent" />
            <div className="products">
                <ImgCellsWithText data={imgCellData} descFamily={'Manrope-SemiBold'} webpUrl={webpUrl} />
                {locale === 'cn' && <p className="memo">{languageT('memo')}</p>}
            </div>
            <LineSpace height={280} background="transparent" />
            <OtherList
                data={getDetaileMoreProducts(
                    gloproductlist,
                    product[locale] || product.us,
                    '',
                    '',
                    `https://${locale}.ecoflow.com/collections/portable-power-stations`,
                )}
            />
        </div>
    );
}
